import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "../../Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "../../Redux/Actions/actionTypes";
import * as FileManagementActions from "../../Redux/Actions/FileManagementAction";
import FileListRequest from "../../Communication/ApiClasses/FileListRequest";

// worker
function* handleFileListRequest(action) {
  yield put(doLoadingStart(`${actionTypes.FILE_LIST_REQUEST}_SAGA`));

  const { params, callback } = action.payload;
  const {
    accountId,
    page = 0,
    size = 20,
    fileType = null,
    sortBy = "uploadedAt",
    sortDirection = "DESC",
  } = params || {};

  const fileListApi = new FileListRequest(
    accountId,
    page,
    size,
    fileType,
    sortBy,
    sortDirection
  );

  try {
    const result = yield call(fileListApi.getData.bind(fileListApi));
    yield put(FileManagementActions.getFileListSuccess(result));
    if (callback) {
      yield call(callback, result);
    }
  } catch (error) {
    yield put(FileManagementActions.getFileListError(error.response || error));
    if (callback) {
      yield call(callback, error.response || error);
    }
  } finally {
    yield put(doLoadingFinish(`${actionTypes.FILE_LIST_REQUEST}_SAGA`));
  }
}

// watcher
export default function* fileListWatcherSaga() {
  yield takeLatest(actionTypes.FILE_LIST_REQUEST, handleFileListRequest);
}
